import { Chart } from 'primereact/chart';
import { useEffect, useState } from 'react';
import { MonthlySales } from '../../Domain/Model/Metric';

interface ChartBasicProps {
    dataMonthlySales: MonthlySales[];
    onYearChange: (year: number) => void;
}

export default function ChartBasic({ dataMonthlySales, onYearChange }: ChartBasicProps) {
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    const [period, setPeriod] = useState('0');

    const currentYear = new Date().getFullYear();
    const years: number[] = [];
    for (let year = currentYear; year >= 2020; year--) {
        years.push(year);
    }

    useEffect(() => {

       
        const salesList = dataMonthlySales.map((item) => {
            return item.totalSales;
        });

        const data = {
            labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            // labels: MonthData,
            datasets: [
                {
                    label: 'Sales',
                    // data: [540, 325, 702, 620, 300, 200, 800, 400, 450, 600, 550, 800],
                    data: salesList,
                    backgroundColor: [
                        '#ff8780',
                      ],
                      borderColor: [
                        '#d9342b',
                      ],
                      borderWidth: 1
                }
            ]
        };
        const options = {
            scales: {
                y: {
                    beginAtZero: true
                }
            },
            plugins: {
                legend: {
                    display: false,
                }
            }
        };
         
        setChartData(data);
        setChartOptions(options);

    }, [dataMonthlySales]);

    return (
        <div className="card card-chart">
            <div className='selected-content-year-chart'>
                <p>Ventas</p>
                <select className="form-select"  value={period} onChange={(e) => {
                    const selectedIndex = parseInt(e.target.value);
                    const selectedYear = years[selectedIndex];
                    setPeriod(e.target.value);
                    onYearChange(selectedYear);
                }}>
                    {years.map((year, index) => (
                        <option key={year} value={index.toString()}>{year}</option>
                    ))}
                </select>
            </div>
            {dataMonthlySales ? <Chart type="bar" data={chartData} options={chartOptions} /> : <div>Cargando...</div>}
        </div>
    )
}